import { useCallback, useEffect, useRef, useState } from "react";
import DeleteConfirmModal from "@/components/DeleteConfirmModal";

const DEFAULT_STORAGE_KEY = "cp_skip_delete_confirm";

export default function useDeleteConfirm(storageKey = DEFAULT_STORAGE_KEY) {
  const [dialog, setDialog] = useState(null);
  const resolverRef = useRef(null);

  const close = useCallback((result, dontAskAgain = false) => {
    if (dontAskAgain) {
      try {
        window.localStorage.setItem(storageKey, "1");
      } catch {
        // no-op (private mode / blocked storage)
      }
    }
    const resolver = resolverRef.current;
    resolverRef.current = null;
    setDialog(null);
    if (resolver) resolver(result);
  }, [storageKey]);

  const confirmDelete = useCallback((options = {}) => {
    let skip = false;
    try {
      skip = window.localStorage.getItem(storageKey) === "1";
    } catch {
      skip = false;
    }
    if (skip) return Promise.resolve(true);
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setDialog({
        title: options.title || "Confirmar exclusão",
        message: options.message || "Tem certeza que deseja excluir este item?",
      });
    });
  }, [storageKey]);

  useEffect(() => () => {
    if (resolverRef.current) {
      resolverRef.current(false);
      resolverRef.current = null;
    }
  }, []);

  const deleteConfirmDialog = (
    <DeleteConfirmModal
      open={Boolean(dialog)}
      title={dialog?.title}
      message={dialog?.message}
      onCancel={() => close(false)}
      onConfirm={(dontAskAgain) => close(true, dontAskAgain)}
    />
  );

  return { confirmDelete, deleteConfirmDialog };
}
